{
  "general": {
    "title": "Erro",
    "unknown": "Ocorreu um erro inesperado",
    "tryAgain": "Por favor, tente novamente mais tarde",
    "contactSupport": "Se o problema persistir, entre em contato com o suporte"
  },
  "404": {
    "title": "Página Não Encontrada",
    "message": "A página que você está procurando não existe",
    "action": "Ir para Início"
  },
  "403": {
    "title": "Acesso Negado",
    "message": "Você não tem permissão para acessar este recurso",
    "action": "Voltar"
  },
  "500": {
    "title": "Erro do Servidor",
    "message": "Algo deu errado em nosso servidor",
    "action": "Atualizar Página"
  },
  "network": {
    "title": "Erro de Rede",
    "offline": "Você parece estar offline",
    "slow": "Conexão está lenta",
    "timeout": "Tempo de requisição esgotado",
    "retry": "Tentar Novamente"
  },
  "auth": {
    "invalidCredentials": "Email ou senha inválidos",
    "accountLocked": "Conta foi bloqueada",
    "sessionExpired": "Sua sessão expirou",
    "unauthorized": "Por favor, faça login para continuar",
    "emailNotVerified": "Por favor, verifique seu endereço de email"
  },
  "validation": {
    "required": "Este campo é obrigatório",
    "email": "Por favor, insira um email válido",
    "password": "A senha deve ter pelo menos 8 caracteres",
    "passwordMatch": "As senhas não coincidem",
    "terms": "Você deve aceitar os termos"
  },
  "api": {
    "requestFailed": "Requisição falhou",
    "serverError": "Erro do servidor",
    "badRequest": "Requisição inválida",
    "notFound": "Recurso não encontrado",
    "conflict": "Conflito de recurso"
  }
}
